import Vue from 'vue';
import _ from 'lodash';

export default {
  state: {
    products: null,
  },
  getters: {
    PRODUCTS: state => {
      return state.products;
    },
  },
  mutations: {
    SET_PRODUCTS: (state, payload) => {
      state.products = payload;
    },
  },
  actions: {
    INIT_PRODUCTS: async (context) => {
      try {
        const shopPriceListId = context.getters.ALBUM.shop_pricelist_id;
        const albumId = context.getters.ALBUM.id;

        if (+shopPriceListId) {
          const products = await Vue.axios.get(
              `v2/categories?album=${albumId}&pricelist=${shopPriceListId}`);

          if (products && products.data) {
            context.commit('SET_PRODUCTS', products.data.data.map((item) => {
              const products = item.products;

              products.map((product) => {
                product.variants.map((variant) => {
                  variant.price = parseFloat(variant.price_gross);
                  return variant;
                });
                product.price = product.variants.length === 1 ?
                    _.first(product.variants).price :
                    0;
              });

              return {
                id: item.id,
                name: item.name,
                description: item.description || '',
                slug: +item.is_digital ? 'digital' : 'default',
                isDigital: +item.is_digital,
                isDownloadable: +item.is_downloadable,
                blockedAlbumItems: item.blocked_album_items ? item.blocked_album_items : null,
                sets: item.pricelist_sets && item.pricelist_sets.length > 0 ? item.pricelist_sets : null,
                images: item.images,
                items: products,
              };
            }));
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
  },
};